<template>
	<section>
		<!--图片部分-->
		<div class="screenshot">
			<div v-for="(item, index) in srcList" :key="index" class="img_list">
				<img class="el-upload-list__item-thumbnail" :src="item" alt="" />
			</div>
			<div
				v-loading="loading1"
				class="up-btn"
				style="
					width: 100px;
					height: 100px;
					line-height: 100px;
					box-sizing: border-box;
				"
				@click="getPolicy"
			>
				<i class="el-icon-plus"></i>
			</div>
		</div>
		<input type="file" ref="file" @change="getFile" />
	</section>
</template>

<script>
import axios from "axios";

export default {
	props: ["keyWord", "params"],
	data() {
		return {
			loading1: false, //加载中
			srcList: [], //上传图片数组
			isMoer: true,

			getKeyWord: this.keyWord, //接收动态keyWord的值
			myParams: this.params, //接收动态params的值

			s3Config: "",
		};
	},
	created() {
		this.wake(); //初始化--回显图片
	},
	mounted() {
		// this.wake();//初始化--回显图片
	},
	watch: {
		myParams() {},
	},
	methods: {
		wake() {
			this.srcList = [];
			if (
				this.myParams[this.getKeyWord] &&
				this.myParams[this.getKeyWord] != ""
			) {
				this.srcList[0] = this.myParams[this.getKeyWord];
				this.isMoer = false;
			} else {
				this.isMoer = true;
			}
		},
		//获取文件
		getPolicy() {
			this.$refs.file.dispatchEvent(new MouseEvent("click"));
		},
		async getFile() {
			var file = this.$refs.file.files[0];
			let fileName = this.getTimes() + "." + this.getCaption(file.name, 1);
			// this.setOssUpload(fileName)
			this.uploadS3Img(fileName);
		},
		async uploadS3Img(fileName) {
			this.loading1 = true;
			const { data: resData } = await this.$get("s3/config/info", {});
			if (resData.result != 200) return;
			this.s3Config = resData.data;
			// var albumBucketName = resData.data.bucketName
			// var bucketRegion = resData.data.bucketRegion
			// var targetRegion = resData.data.targetBucketRegion
			// var IdentityPoolId = resData.data.identityPoolId
			// AWS.config.update({
			//   region: bucketRegion,
			//   credentials: new AWS.CognitoIdentityCredentials({
			//     IdentityPoolId: IdentityPoolId
			//   })
			// })
			const accountid = "05e3a3acf3a5440a0f6aa4e94818fac2";
			const accessKeyId = "adfaeaebf3a0adc777a2365aa4f7500a";
			const accessKey =
				"93f858b5e3e7d01f34dc25fcd0e228c61124872996059c2ec464a0431e0355b4";
			var s3 = new AWS.S3({
				// apiVersion: '2006-03-01',
				// region: targetRegion,
				params: { Bucket: "static-taotan" },
				endpoint: `https://${accountid}.r2.cloudflarestorage.com`,
				accessKeyId: `${accessKeyId}`,
				secretAccessKey: `${accessKey}`,
				signatureVersion: "v4",
			});

			var files = this.$refs.file.files[0];
			var fileName = fileName;
			var albumPhotosKey = "micros/";
			var photoKey = albumPhotosKey + fileName;
			console.log("s3", s3);
			s3.upload(
				{
					// Bucket: "taotan",
					Key: photoKey,
					Body: files,
				},
				(error, data) => {
					if (error) {
						this.$message.error("服务器异常，重新试一下");
					} else {
						let domain = this.s3Config.domain;
						let imgurl = `${domain}/${data.key}`;
						this.isMoer = false;
						this.loading1 = false;
						this.srcList = [imgurl];
						this.myParams[this.getKeyWord] = this.srcList[0];
					}
				}
			);
		},
		//oss文件上传
		async setOssUpload(fileName) {
			this.loading1 = true;
			const that = this;
			const { data: resData } = await this.$get("aliyun/oss/sign", {});
			if (resData.result != 200) return;
			const addRoutes = await this.ossUpload(
				that.$refs.file.files[0],
				resData.data,
				"one", //'more','one',
				[],
				fileName
			);
			this.isMoer = false;
			this.loading1 = false;
			this.srcList = addRoutes;
			this.myParams[this.getKeyWord] = this.srcList[0]; //赋值相应的字段
		},
		//oss上传封装
		async ossUpload(file, ossToken, type, arr, fileName) {
			let formData = new FormData();
			//注意formData里append添加的键的大小写
			formData.append("key", ossToken.dir + fileName); //存储在oss的文件路径
			formData.append("OSSAccessKeyId", ossToken.accessid); //accessKeyId
			formData.append("policy", ossToken.policy); //policy
			formData.append("Signature", ossToken.signature); //签名
			formData.append("success_action_status", 200); //成功后返回的操作码
			//如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
			formData.append("file", file);
			await axios
				.post(ossToken.host, formData, {
					"Content-Type": "multipart/form-data",
				})
				.then((res) => {
					if (res.status == 200) {
						let imgurl = `${ossToken.host2}/${ossToken.dir}${fileName}`;
						if (type == "one") {
							arr = [];
							arr.push(imgurl);
						} else {
							arr.push(imgurl);
						}
					}
				});
			return arr;
		},
		//获取文件后缀
		getCaption(obj, state) {
			let index = obj.lastIndexOf("\.");
			if (state == 0) {
				obj = obj.substring(0, index);
			} else {
				obj = obj.substring(index + 1, obj.length);
			}
			return obj;
		},
		//获取当前时间作为文件上传的名称
		getTimes() {
			let data = new Date();
			let year = data.getFullYear().toString();
			let month = data.getMonth() + 1;
			return (
				year +
				month +
				data.getDate() +
				data.getHours() +
				data.getMinutes() +
				data.getSeconds() +
				data.getMilliseconds()
			);
		},
	},
};
</script>

<style></style>
<style scoped lang="scss">
//视频和图片上传的图片和视频展示的公共样式
.screenshot {
	display: flex;
	align-items: center;
	flex-wrap: wrap;

	.img_list {
		width: 100px;
		height: 100px;
		margin-right: 5px;
		border: 1px dashed #d9d9d9;
		box-sizing: border-box;
		padding: 3px;
		position: relative;
		box-sizing: border-box;
		border-radius: 6px;

		.el-upload-list__item-thumbnail {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		.el-upload-list__item-actions {
			width: 100px;
			height: 100px;
			position: absolute;
			background: rgba(0, 0, 0, 0.5);
			top: 0;
			left: 0;
			transition: opacity 0.3s;
			opacity: 0;

			i {
				color: #ffffff;
				font-size: 18px;
			}

			.el-upload-list__item-delete {
				//position: static;
				color: #ffffff;
				right: 20px;
				display: block;
				top: 50%;
				transform: translateY(-50%);
			}

			.el-upload-list__item-preview {
				left: 20px;
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
			}
		}

		.el-upload-list__item-actions:hover {
			opacity: 1;
		}
	}

	.img_box_upload {
		width: 100px;
		height: 100px;
		margin-bottom: 5px;
	}
}
</style>

<style lang="scss">
//视频和图片上传的上传按钮公共样式
.screenshot {
	.el-upload.el-upload--picture-card {
		width: 100%;
		line-height: 100px;
		height: 100%;

		.el-icon-plus {
			font-size: 24px;
		}
	}
}
</style>
